<template>
    <div class="file-manage-container">
        <!-- 标签页切换 -->
        <div class="tabs-container">
            <el-tabs v-model="activeTab" @tab-click="handleTabClick" type="card">
                <el-tab-pane label="文件管理" name="file">
                    <div class="tab-content">
                        <div class="task-section">
                            <div class="search-box">
                                <el-input 
                                    v-model="fileSearch" 
                                    placeholder="请输入任务标题" 
                                    clearable
                                    @keyup.enter.native="loadFileList()"
                                    style="width: 350px;">
                                    <i slot="prefix" class="el-icon-search"></i>
                                </el-input>
                                <el-button type="primary" icon="el-icon-search" @click="loadFileList()">查询</el-button>
                                <el-button icon="el-icon-refresh" @click="resetFileSearch()">重置</el-button>
                            </div>
                            <div class="task-table">
                                <el-table 
                                    :data="fileList" 
                                    border 
                                    stripe
                                    style="width: 100%"
                                    :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}"
                                    empty-text="暂无数据"
                                    ref="table"
                                    height="calc(100vh - 350px)">
                                    
                                    <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                                    <el-table-column prop="L_Title" label="任务标题" min-width="150" align="center" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="L_AddTime" label="创建时间" width="160" align="center">
                                        <template slot-scope="{ row }">
                                            {{ GetDateTimeString(row.L_AddTime) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="L_Field4" label="任务状态" width="200" align="center">
                                        <template slot-scope="{ row }">
                                            <el-tooltip v-if="isRunning(row.L_Field4)" :content="row.L_Field4" placement="top">
                                                <el-progress :percentage="getPercent(row.L_Field4)" :text-inside="true" :stroke-width="16" class="status-progress"></el-progress>
                                            </el-tooltip>
                                            <el-tag v-else-if="row.L_Field4 === '生成完毕'" type="success" size="small">生成完毕</el-tag>
                                            <el-tag v-else-if="isWaiting(row.L_Field4)" type="info" size="small">{{ row.L_Field4 || '等待处理' }}</el-tag>
                                            <el-tag v-else type="danger" size="small">失败</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="报错信息" min-width="150" align="center">
                                        <template slot-scope="{ row }">
                                            <el-button v-if="getErrorInfo(row)" type="text" size="small" class="error-link" @click="showError(row)">
                                                <i class="el-icon-warning"></i> 查看详情
                                            </el-button>
                                            <span v-else class="text-muted">-</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="L_Field3" label="解压密码" width="100" align="center"></el-table-column>
                                    <el-table-column label="操作" width="260" align="center" fixed="right">
                                        <template slot-scope="{ row }">
                                            <el-button 
                                                v-if="row.L_Field3 && row.L_Field1" 
                                                type="text" 
                                                size="small" 
                                                @click="handleDownload(row)">
                                                <i class="el-icon-download"></i> 下载
                                            </el-button>
                                            <el-button 
                                                type="text" 
                                                size="small" 
                                                @click="handleDelete(row, 'file')">
                                                <i class="el-icon-delete"></i> 删除
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div class="task-pagination-container">
                                <el-pagination
                                    @size-change="handleFileSizeChange"
                                    @current-change="handleFileCurrentChange"
                                    :current-page="filePageInfo.CurPage"
                                    :page-sizes="[20, 50, 100, 200]"
                                    :page-size="filePageInfo.RecordCountOfPage"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="filePageInfo.RecordCount">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="通知书下载" name="notice">
                    <div class="tab-content">
                        <div class="task-section">
                            <div class="search-box">
                                <el-input 
                                    v-model="noticeSearch" 
                                    placeholder="请输入任务标题" 
                                    clearable
                                    @keyup.enter.native="loadNoticeList()"
                                    style="width: 350px;">
                                    <i slot="prefix" class="el-icon-search"></i>
                                </el-input>
                                <el-button type="primary" icon="el-icon-search" @click="loadNoticeList()">查询</el-button>
                                <el-button icon="el-icon-refresh" @click="resetNoticeSearch()">重置</el-button>
                            </div>
                            <div class="task-table">
                                <el-table 
                                    :data="noticeList" 
                                    border 
                                    stripe
                                    style="width: 100%"
                                    :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}"
                                    empty-text="暂无任务">
                                    
                                    <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                                    <el-table-column prop="L_Title" label="任务标题" min-width="150" align="center" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="L_AddTime" label="创建时间" width="160" align="center">
                                        <template slot-scope="{ row }">
                                            {{ GetDateTimeString(row.L_AddTime) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="L_Field4" label="任务状态" width="200" align="center">
                                        <template slot-scope="{ row }">
                                            <el-tooltip v-if="isRunning(row.L_Field4)" :content="row.L_Field4" placement="top">
                                                <el-progress :percentage="getPercent(row.L_Field4)" :text-inside="true" :stroke-width="16" class="status-progress"></el-progress>
                                            </el-tooltip>
                                            <el-tag v-else-if="row.L_Field4 === '生成完毕'" type="success" size="small">生成完毕</el-tag>
                                            <el-tag v-else-if="isWaiting(row.L_Field4)" type="info" size="small">{{ row.L_Field4 || '等待处理' }}</el-tag>
                                            <el-tag v-else type="danger" size="small">失败</el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="L_Field3" label="解压密码" width="100" align="center"></el-table-column>
                                    <el-table-column label="报错信息" min-width="150" align="center">
                                        <template slot-scope="{ row }">
                                            <el-button v-if="getErrorInfo(row)" type="text" size="small" class="error-link" @click="showError(row)">
                                                <i class="el-icon-warning"></i> 查看详情
                                            </el-button>
                                            <span v-else class="text-muted">-</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="260" align="center" fixed="right">
                                        <template slot-scope="{ row }">
                                            <el-button 
                                                v-if="row.L_Field3 && row.L_Field1" 
                                                type="text" 
                                                size="small" 
                                                @click="handleDownload(row)">
                                                <i class="el-icon-download"></i> 下载
                                            </el-button>
                                            <el-button 
                                                type="text" 
                                                size="small" 
                                                @click="handleDelete(row, 'notice')">
                                                <i class="el-icon-delete"></i> 删除
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <div class="task-pagination-container">
                                <el-pagination
                                    @size-change="handleNoticeSizeChange"
                                    @current-change="handleNoticeCurrentChange"
                                    :current-page="noticePageInfo.CurPage"
                                    :page-sizes="[20, 50, 100, 200]"
                                    :page-size="noticePageInfo.RecordCountOfPage"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="noticePageInfo.RecordCount">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import { TYBM_Env } from '../../env.js';
    import { TYBM_Tools } from '../../tools.js';

    export default {
        name: 'FileManage',
        data: function () {
            return {
                activeTab: 'file',
                // 文件管理
                fileList: [],
                filePageInfo: {
                    CurPage: 1,
                    PageCount: 1,
                    RecordCount: 1,
                    RecordCountOfPage: 20
                },
                fileSearch: '',
                // 通知书下载
                noticeList: [],
                noticePageInfo: {
                    CurPage: 1,
                    PageCount: 1,
                    RecordCount: 1,
                    RecordCountOfPage: 20
                },
                noticeSearch: '',
                // 轮询
                pollTimer: null,
                lastPollTime: 0,
                pollInterval: 5000
            }
        },
        created: function () {
            // 根据路由参数决定默认打开哪个标签页
            var type = this.$route.query.type || 'file';
            this.activeTab = type;
            if (type === 'notice') {
                this.loadNoticeList();
            } else {
                this.loadFileList();
            }
        },
        beforeDestroy: function () {
            this.stopPolling();
        },
        methods: {
            handleTabClick: function (tab) {
                if (tab.name === 'notice') {
                    this.loadNoticeList();
                } else {
                    this.loadFileList();
                }
            },
            // ===== 文件管理 =====
            loadFileList: function (pageIdx, pageCount, silent) {
                var that = this;
                var api_name = '/Info/GetFileManageList';
                var url = TYBM_Env.GetApiUrl(api_name) + '?Search=' + encodeURIComponent(that.fileSearch || '');
                var options = silent ? { hide_tip: true } : { loading_msg: '正在加载数据' };
                
                var currentPage = pageIdx || that.filePageInfo.CurPage;
                var currentCount = pageCount || that.filePageInfo.RecordCountOfPage;
                
                TYBM_Tools.AxiosGetEx(that, api_name, TYBM_Tools.AppendPageInfo(url, currentPage, currentCount), options)
                    .then(result => {
                        that.filePageInfo = result.data.PageInfo;
                        that.fileList = result.data.List;
                        if (!silent) {
                            that.checkFilePolling();
                        }
                    }).catch(() => { });
            },
            handleFileSizeChange: function (val) {
                this.filePageInfo.RecordCountOfPage = val;
                this.loadFileList(1, val);
            },
            handleFileCurrentChange: function (val) {
                this.loadFileList(val, this.filePageInfo.RecordCountOfPage);
            },
            resetFileSearch: function () {
                this.fileSearch = '';
                this.loadFileList();
            },
            // ===== 通知书下载 =====
            loadNoticeList: function (pageIdx, pageCount, silent) {
                var that = this;
                var api_name = '/Notice/GetNoticeTaskList';
                var url = TYBM_Env.GetApiUrl(api_name);
                if (that.noticeSearch) {
                    url += '?Search=' + encodeURIComponent(that.noticeSearch);
                }
                var options = silent ? { hide_tip: true } : { loading_msg: '正在加载任务列表' };
                
                var currentPage = pageIdx || that.noticePageInfo.CurPage;
                var currentCount = pageCount || that.noticePageInfo.RecordCountOfPage;
                
                TYBM_Tools.AxiosGetEx(that, api_name, TYBM_Tools.AppendPageInfo(url, currentPage, currentCount), options)
                    .then(result => {
                        that.noticePageInfo = result.data.PageInfo;
                        that.noticeList = result.data.List;
                        if (!silent) {
                            that.checkNoticePolling();
                        }
                    }).catch(() => { });
            },
            handleNoticeSizeChange: function (val) {
                this.noticePageInfo.RecordCountOfPage = val;
                this.loadNoticeList(1, val);
            },
            handleNoticeCurrentChange: function (val) {
                this.loadNoticeList(val, this.noticePageInfo.RecordCountOfPage);
            },
            resetNoticeSearch: function () {
                this.noticeSearch = '';
                this.loadNoticeList();
            },
            // ===== 通用方法 =====
            isRunning: function (status) {
                return !!status && status.indexOf('处理中') >= 0;
            },
            isWaiting: function (status) {
                return !status || status === '等待处理';
            },
            getPercent: function (status) {
                var m = /(\d+)\s*\/\s*(\d+)/.exec(status || '');
                if (m) {
                    var done = parseInt(m[1], 10);
                    var total = parseInt(m[2], 10);
                    if (total > 0) {
                        return Math.min(100, Math.floor(done * 100 / total));
                    }
                }
                return 0;
            },
            getErrorInfo: function (row) {
                if (row.L_Field5) {
                    return row.L_Field5;
                }
                var s = row.L_Field4;
                if (s && s !== '生成完毕' && !this.isRunning(s) && !this.isWaiting(s)) {
                    return s;
                }
                return '';
            },
            showError: function (row) {
                var text = this.getErrorInfo(row);
                if (!text) {
                    return;
                }
                this.$alert(text.replace(/\n/g, '<br>'), '报错信息', {
                    dangerouslyUseHTMLString: true
                });
            },
            GetDateTimeString: function (date) {
                return TYBM_Tools.FormatDate('yyyy-MM-dd HH:mm:ss', new Date(date));
            },
            handleDownload: function (row) {
                if (!row.L_Field1) {
                    this.$message.warning('文件路径不存在');
                    return;
                }
                var downloadUrl = TYBM_Env.ServerHost + row.L_Field1;
                window.open(downloadUrl, '_blank');
                this.$message.success('已开始下载，请等待浏览器提示');
            },
            handleDelete: function (row, type) {
                var that = this;
                that.$confirm('确定要删除此任务记录吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    var api_name = type === 'notice' ? '/Notice/DeleteNoticeTask' : '/Info/DeleteFileManage';
                    var url = TYBM_Env.GetApiUrl(api_name);
                    TYBM_Tools.AxiosPostEx(that, api_name, url, { Model: JSON.stringify({ L_SN: row.L_SN }) }, { loading_msg: '正在删除...' })
                        .then(result => {
                            if (result.code === 'ok') {
                                that.$message.success('删除成功');
                                if (type === 'notice') {
                                    that.loadNoticeList();
                                } else {
                                    that.loadFileList();
                                }
                            } else {
                                that.$message.error(result.errmsg || result.msg || '删除失败');
                            }
                        })
                        .catch(() => {
                            that.$message.error('删除失败');
                        });
                }).catch(() => { });
            },
            // ===== 文件管理轮询 =====
            hasFileRunningTask: function () {
                var that = this;
                return that.fileList.some(function (row) {
                    return that.isRunning(row.L_Field4) || that.isWaiting(row.L_Field4);
                });
            },
            checkFilePolling: function () {
                if (this.hasFileRunningTask()) {
                    this.startFilePolling();
                } else {
                    this.stopPolling();
                }
            },
            startFilePolling: function () {
                var that = this;
                if (that.pollTimer) {
                    clearInterval(that.pollTimer);
                }
                that.pollTimer = setInterval(function () {
                    var now = Date.now();
                    if (now - that.lastPollTime >= that.pollInterval) {
                        that.lastPollTime = now;
                        that.loadFileList(that.filePageInfo.CurPage, that.filePageInfo.RecordCountOfPage, true);
                    }
                }, that.pollInterval);
            },
            // ===== 通知书下载轮询 =====
            hasNoticeRunningTask: function () {
                var that = this;
                return that.noticeList.some(function (row) {
                    return that.isRunning(row.L_Field4) || that.isWaiting(row.L_Field4);
                });
            },
            checkNoticePolling: function () {
                if (this.hasNoticeRunningTask()) {
                    this.startNoticePolling();
                } else {
                    this.stopPolling();
                }
            },
            startNoticePolling: function () {
                var that = this;
                if (that.pollTimer) {
                    clearInterval(that.pollTimer);
                }
                that.pollTimer = setInterval(function () {
                    var now = Date.now();
                    if (now - that.lastPollTime >= that.pollInterval) {
                        that.lastPollTime = now;
                        that.loadNoticeList(that.noticePageInfo.CurPage, that.noticePageInfo.RecordCountOfPage, true);
                    }
                }, that.pollInterval);
            },
            stopPolling: function () {
                if (this.pollTimer) {
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                }
            }
        }
    }
</script>

<style scoped>
.file-manage-container {
    width: 100%;
}

.tabs-container {
    width: 100%;
}

.tab-content {
    padding: 20px 0;
}

.search-box {
    margin-bottom: 20px;
    display: flex;
    gap: 12px;
    align-items: center;
}

.task-section {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
}

.task-table {
    margin-bottom: 20px;
    overflow-x: auto;
}

.task-table >>> .el-table {
    font-size: 13px;
}

.task-table >>> .el-table th,
.task-table >>> .el-table td {
    padding: 0 !important;
    height: 40px !important;
}

.task-table >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.task-table >>> .el-table__row {
    height: 40px !important;
}

.task-table >>> .el-table__row:hover {
    background-color: #f5f9ff;
}

.task-pagination-container {
    text-align: right;
}

.status-progress {
    width: 120px;
}

.error-link {
    color: #f56c6c !important;
}

.error-link:hover {
    color: #f78989 !important;
}

.text-muted {
    color: #909399;
}

.task-table >>> .el-table .cell {
    padding: 0 8px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    line-height: 40px !important;
}

.task-table >>> .el-table th > .cell {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: 100% !important;
    line-height: normal !important;
}

.task-table >>> .el-button--text {
    color: #409EFF;
    padding: 0;
}

.task-table >>> .el-button--text:hover {
    color: #66b1ff;
}

.task-table >>> .el-button--text i {
    margin-right: 4px;
}

.task-table >>> .el-table__fixed-right {
    background-color: white !important;
}

.task-table >>> .el-table__fixed-right-patch {
    background-color: #f5f7fa !important;
}
</style>
